import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const IntegrationContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  h2 {
    font-size: 20px;
    color: ${theme.colours.blackText};
  }
  p {
    font-size: 14px;
    color: ${theme.colours.blackText};
  }
  .categoryName {
    color: ${theme.colours.mainBlue};
    cursor: pointer;
  }
  .active {
    background-color: #c8e5d0;
    color: ${theme.colours.blackText};
    font-size: 14px;
    border-radius: 4px;
    padding: 3px 8px;
  }
  .deactive {
    background-color: #eeeeee;
    color: ${theme.colours.blackText};
    font-size: 14px;
    border-radius: 4px;
    padding: 3px 8px;
  }
  @media (max-width: 767.5px) {
    .small-screen {
      display: flex;
      margin-top: 0 !important;
    }
  }
`;
